import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { getServicesUrl, V20 } from '../../setup';
import Service from './service';

var Compliance =
/*#__PURE__*/
function (_Service) {
  _inherits(Compliance, _Service);

  function Compliance() {
    _classCallCheck(this, Compliance);

    return _possibleConstructorReturn(this, _getPrototypeOf(Compliance).apply(this, arguments));
  }

  _createClass(Compliance, null, [{
    key: "getCampaignsCurrentConfiguration",
    value: function getCampaignsCurrentConfiguration(productId) {
      var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
      return Service.getRequest("".concat(getServicesUrl(), "/questionnaires?productid=").concat(productId, "&language=").concat(language), {
        isSecure: true
      });
    }
  }, {
    key: "filterQuestionnaires",
    value: function filterQuestionnaires(data) {
      return Service.postRequest("".concat(getServicesUrl(V20), "/questionnaires"), data, {
        isSecure: true
      });
    }
    /**
     * Get Questionnaire by ContactId and ProductId
     * Warning: This version is deprecated - Please use the v2.0 version
     * @param {contactId} number.
     * @param {productId} number.
     * @param {language} string.
     */

  }, {
    key: "getQuestionnaireByContactAndProduct",
    value: function getQuestionnaireByContactAndProduct(contactId, productId) {
      var language = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
      return Service.postRequest("".concat(getServicesUrl, "/contacts/").concat(contactId, "/questionnaires?productid=").concat(productId, "&empty=true&iscomplete=true&language=").concat(language), {
        isSecure: true
      });
    }
    /**
     * Get Questionnaire by ContactId and ProductId - v2.0
     * @param {contactId} number.
     * @param {productId} number.
     * @param {data} json
     * data json:
     * {
     *   Language: 'en',
     *   ProductId: @param {productId},
     *   IsComplete: true,
     *   Empty: true,
     *   QuestionnaireTypeId: 1
     * }
     */

  }, {
    key: "getQuestionnaireByContactAndProductV20",
    value: function getQuestionnaireByContactAndProductV20(contactId, productId, data) {
      return Service.postRequest("".concat(getServicesUrl(V20), "/contacts/").concat(contactId, "/questionnaires"), data, {
        isSecure: true
      });
    }
  }, {
    key: "postQuestionnaires",
    value: function postQuestionnaires(contactId, data) {
      return Service.postRequest("".concat(getServicesUrl(V20), "/contacts/").concat(contactId, "/questionnaires"), data, {
        isSecure: true
      });
    }
  }, {
    key: "postAnswers",
    value: function postAnswers(contactId, data) {
      return Service.postRequest("".concat(getServicesUrl(), "/contacts/").concat(contactId, "/questionnaires"), data, {
        isSecure: true
      });
    }
  }, {
    key: "calculateRisk",
    value: function calculateRisk(contactId, productId, acceptRistk) {
      var groupkey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var completequestionnaire = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var language = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'en';
      return Service.getRequest("".concat(getServicesUrl(), "/contacts/").concat(contactId, "/calculaterisk?productid=").concat(productId, "&groupkey=").concat(groupkey, "&completequestionnaire=").concat(completequestionnaire, "&riskaccepted=").concat(acceptRistk, "&language=").concat(language), {
        isSecure: true
      });
    }
  }, {
    key: "acceptRisk",
    value: function acceptRisk(contactId) {
      return Service.postRequest("".concat(getServicesUrl(), "/contacts/").concat(contactId, "/acceptrisk"), {}, {
        isSecure: true
      });
    }
  }, {
    key: "setChosenRisk",
    value: function setChosenRisk(contactId, chosenRiskId) {
      return Service.postRequest("".concat(getServicesUrl(), "/contacts/").concat(contactId, "/setchosenrisk/").concat(chosenRiskId), {}, {
        isSecure: true
      });
    }
  }, {
    key: "chooseRisk",
    value: function chooseRisk(contactId) {
      return Service.getRequest("".concat(getServicesUrl(), "/contacts/").concat(contactId, "/setchosenrisk"), {
        isSecure: true
      });
    }
  }, {
    key: "getAllActiveQuestionnaires",
    value: function getAllActiveQuestionnaires(data) {
      return Service.postRequest("".concat(getServicesUrl(V20), "/questionnaires"), data, {
        isSecure: true
      });
    }
  }]);

  return Compliance;
}(Service);

export default Compliance;